import { schema } from "normalizr";

export const smartPlanSchema = new schema.Entity("smartPlan");

export const smartPlansSchema = new schema.Array(smartPlanSchema);
